var _path, _path2, _g, _path3, _g2, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoContent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1088_3100)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1088_3100)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.3648 42.0262L30 81.2182V131.977C30 140.274 36.726 147 45.023 147H132.977C141.274 147 148 140.274 148 131.977V81.2182L125.152 41.9808C124.078 40.1352 122.103 39 119.967 39H57.576C55.4216 39 53.4325 40.1551 52.3648 42.0262Z",
    fill: "url(#paint0_linear_1088_3100)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1088_3100",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 39,
    width: 118,
    height: 108
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3648 42.0262L30 81.2182V131.977C30 140.274 36.726 147 45.023 147H132.977C141.274 147 148 140.274 148 131.977V81.2182L125.152 41.9808C124.078 40.1352 122.103 39 119.967 39H57.576C55.4216 39 53.4325 40.1551 52.3648 42.0262Z",
    fill: "url(#paint1_linear_1088_3100)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1088_3100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55 39V81.2182V147H123V81.2182V39H55Z",
    fill: "url(#paint2_linear_1088_3100)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1696 101.376C78.5917 96.1269 76.4709 81.0553 80.3021 74.7567C84.1299 69.7134 89.5182 72.2464 91.1581 76.046C93.8913 82.3786 83.1311 89.0653 78.7322 79.4234C71.5488 63.6781 88.8153 56.2044 95.4531 56.2039",
    stroke: "url(#paint3_linear_1088_3100)",
    strokeWidth: 2.50383,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.25 5.01"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1088_3100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.35 88.3881C68.35 84.3077 65.0422 81 60.9619 81H30V131.977C30 140.274 36.726 147 45.023 147H132.977C141.274 147 148 140.274 148 131.977V81H117.038C112.958 81 109.65 84.3077 109.65 88.3881C109.65 92.4684 106.342 95.7761 102.262 95.7761H75.7381C71.6577 95.7761 68.35 92.4684 68.35 88.3881Z",
    fill: "url(#paint4_linear_1088_3100)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.8246 95.3784C73.7142 95.7588 74.6937 95.9695 75.7225 95.9695H102.272C106.346 95.9695 109.647 92.6676 109.647 88.5945C109.647 84.5214 112.949 81.2195 117.022 81.2195H147.997V132.08C147.997 140.377 141.271 147.103 132.975 147.103H124.398L72.7734 95.4786L72.8246 95.3784Z",
    fill: "url(#paint5_linear_1088_3100)"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5317 59.4458L150.858 38.7635L87.7528 43.9498L86.7494 58.0605C86.6808 59.0252 87.6139 59.7503 88.5317 59.4458Z",
    fill: "url(#paint6_linear_1088_3100)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.776 65.7105L150.86 38.7635L90.1445 49.0501L100.133 64.8073C100.91 66.034 102.515 66.4319 103.776 65.7105Z",
    fill: "url(#paint7_linear_1088_3100)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5866 45.1974L150.858 38.7625L82.3266 33.3422C80.6747 33.2116 79.658 35.1095 80.6819 36.4123L87.5866 45.1974Z",
    fill: "url(#paint8_linear_1088_3100)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1088_3100",
    x: 9.96939,
    y: 33.9923,
    width: 158.061,
    height: 148.164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15.023
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.0153
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.156 0 0 0 0 0.208 0 0 0 0 0.26 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1088_3100"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1088_3100",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1088_3100",
    x: 30,
    y: 81,
    width: 118,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.50383
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.825554 0 0 0 0 0.830047 0 0 0 0 0.879474 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1088_3100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1088_3100",
    x1: 89,
    y1: 39,
    x2: 89,
    y2: 147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CED0D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1088_3100",
    x1: 89,
    y1: 39,
    x2: 89,
    y2: 147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CED0D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1088_3100",
    x1: 89.2411,
    y1: 39,
    x2: 89.2411,
    y2: 147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD4E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1088_3100",
    x1: 87.2535,
    y1: 54.9374,
    x2: 87.2535,
    y2: 101.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE4454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE4454",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1088_3100",
    x1: 61.0259,
    y1: 81.9851,
    x2: 90.8493,
    y2: 167.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0095307,
    stopColor: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374871,
    stopColor: "#E9ECF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2D8E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1088_3100",
    x1: 110.385,
    y1: 81.2195,
    x2: 110.385,
    y2: 147.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EA0B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C0CC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1088_3100",
    x1: 145.822,
    y1: 38.9999,
    x2: 85.0461,
    y2: 57.8456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4E5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4E5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1088_3100",
    x1: 120.502,
    y1: 38.7635,
    x2: 120.502,
    y2: 67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB4C53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1088_3100",
    x1: 84.5959,
    y1: 29,
    x2: 114.489,
    y2: 45.0857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE907D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1088_3100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoContent);
export default __webpack_public_path__ + "static/media/no_content.edfd234c1da65c89268c02aee9e1cf86.svg";
export { ForwardRef as ReactComponent };